import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BetslipKeyboardButton from './BetslipKeyboardButton';
import { getCurrencyIso } from '~shared/utils/user';
import { getDecimalSeparator } from '~shared/utils/currencyUtils';
import getMappings from '~shared/locales/betslipKeyboardMappings';
import { connect } from 'react-redux';

const BetslipKeyboard = props => {
    const { getMappings, isBabyBetslip } = props;
    const [ mappings, setMappings ] = useState(null);
    const keyboardClassName = isBabyBetslip ? 'baby-betslip-keyboard__row' : 'betslip-fancy-keyboard__row';

    useEffect(() => {
        const mount = async () => {
            const _mappings = await getMappings(getCurrencyIso());
            setMappings(_mappings);
        };
        mount();
    }, []);

    if (!mappings) {
        return null;
    }

    const buttons = mappings.map((row, index) => {
        const buttonKey = isBabyBetslip ? 'baby-' : '';

        return (
            <div
                key={`${buttonKey}betslip-keyboard-${index}`}
                className={keyboardClassName}
            >
                {row.map((column, buttonIndex) => {

                    return (
                        <BetslipKeyboardButton
                            className="betslip-keyboard__container"
                            key={`${buttonKey}button-${index}-${buttonIndex}`}
                            value={column.isDotSign? getDecimalSeparator(): column.value}
                            isQa={column.isQa}
                            isDotSign={column.isDotSign}
                            isDeleteButton={column.isDeleteButton}
                            isDoneButton={column.isDoneButton}
                            isBabyBetslip={isBabyBetslip}
                            isIncrementButton={column.isIncrementButton}
                        />
                    );
                })}
            </div>
        );
    });

    return <div className="betslip-keyboard">{buttons}</div>;
};

BetslipKeyboard.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
    isBabyBetslip: PropTypes.bool,
    getMappings: PropTypes.func.isRequired,
};

BetslipKeyboard.defaultProps = {
    getMappings,
    isBabyBetslip: false,
};

const mapStateToProps = ({ data }) => {
    return {
        isVisible: data.keyboard_visible,
    };
};

const _BetslipKeyboardContainer = ({isVisible, ...props}) => {
    if(!isVisible) {
        return null;
    }

    return <BetslipKeyboard {...props} />;
};

_BetslipKeyboardContainer.propTypes = {
    isVisible: PropTypes.bool,
};

_BetslipKeyboardContainer.defaultProps = {
    isVisible: false,
};


export const BetslipKeyboardContainer = connect(mapStateToProps)(_BetslipKeyboardContainer);

export default BetslipKeyboard;
